import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_3: FaireProductEntity = {
  token: "atc_toast_3",
  type: "product",
  name: "Half & Half Tea 12 Pack",
  brandName: "Halfday Tonics",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/22c2b5be7f6f4d04ab9fe59594590d2b10e43c46a90b71d95754d064c3ef2f68.webp",
  priceDollars: 24.0,
  msrpDollars: 48.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
